import React, { useState } from 'react';
import axios from 'axios';
import "../../App.css";
import './LoginAdmin.css';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../api';

function LoginAdmin({ setIsAdminLoggedIn }) { // Make sure this matches
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/login`, { email, password });
      const { token } = response.data;
      localStorage.setItem('token', token); // Store the token in localStorage or context
      localStorage.setItem('isAdminLoggedIn', 'true'); // Store login state in localStorage
      setIsAdminLoggedIn(true); // Update the state in App
      setError('');
      navigate('/admin/dashboard'); // Redirect to the dashboard page
    } catch (error) {
      setError(error.response?.data?.error || 'Invalid email or password');
    }
  };

  return (
    <div className="login-admin">
      <h2>Admin Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleLogin}>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginAdmin;